import {HostListener, Injectable} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HelperService {
  /**
   * Détection résolution écran
   * https://stackoverflow.com/a/49917082/55465
   * @param event
   */
  @HostListener('window:resize', ['$event'])
  public  getScreenSize(event?): [number, number] {
    return [window.innerHeight, window.innerWidth];
  }
}
